import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faLaptop, faRedo } from '@fortawesome/free-solid-svg-icons'
import { androidAppDownload, iphoneAppDownload, iphoneRedeemCode } from '../link-actions';
import LogoText from '../components/logoText';
import {Pricing} from "../components/Pricing";
import Carousel from "react-multi-carousel";


const PracticeLoop = () => {
	let sportKey = "golf";

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

	return (<>
		<section id="home" className="black-smoke-background">
          <div className="non-landing-banner-clear"></div>
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-7 col-md-6 col-12 atf-single-details text-lg-left text-center">
						<h2 style={{ fontSize: '32px', marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa' }}>Improve any physical skill. <span style={{color:'yellowgreen'}}>Faster!</span></h2>
						<div className="col-12 text-center">
							<a href="#none" onClick={() => iphoneAppDownload('top_banner')} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
							<a href="#none" onClick={() => androidAppDownload('top_banner')} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
						</div>

					</div>
					<div className="col-lg-5 col-md-6 col-12 text-center">
						<div className="atf-img-inner wow fadeInLeft" data-wow-duration="2s" data-wow-delay="0.4s" data-wow-offset="0"  style={{marginBottom: '20px'}}>
							<div className="home-image-box">
								<div style={{ marginTop: '10px', marginBottom: '25px' }}>
									<LogoText style={{ fontSize: '26px' }} />
									<p style={{ fontSize: '11px', marginTop: '-8px' }}>Skill improvement with each loop</p>
								</div>

								<div>
									<FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '60px' }}></FontAwesomeIcon>
									<h3 className="shake-1">Execute</h3>
									<p>Perform skill in front of your phone camera</p>
								</div>
								<div>
									<FontAwesomeIcon icon={faRedo} className="loopSpinner"></FontAwesomeIcon>
								</div>
								<div>
									<FontAwesomeIcon icon={faLaptop} style={{ color: 'var(--thm-color)', fontSize: '40px', marginBottom: '5px' }}></FontAwesomeIcon>
									<FontAwesomeIcon icon={faTabletAlt} style={{ color: 'var(--thm-color)', fontSize: '60px', margin: '0px 20px 0 20px' }}></FontAwesomeIcon>
									<FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '40px', margin: '0px 25px 5px 5px' }}></FontAwesomeIcon>
									<h3 className="shake-2">Learn and improve</h3>
									<p>Stream real-time video to a second device</p>
								</div>
							</div>
						</div>

					</div>

				</div>
				<div className="d-block d-lg-none row justify-content-center clearfix mt-4">
                                        <div className="text-center align-self-center p-2">
                                            <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                                                <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                                                
                                                <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                                                <a href="#" onClick={() => iphoneRedeemCode("ANALYZER26")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                                    
                                                <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                                                <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 13 Apr 2026</div>
                                            </div>
                                        </div>
                                </div>
			</div>
		</section>

        <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Real-time analysis</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 0px 0"  }}>of <a href="./golf" style={{textDecoration: 'underline', fontWeight: 'bold'}}>golf swings</a> and <a href="./cricket" style={{textDecoration: 'underline', fontWeight: 'bold'}}>cricket bowling</a> actions.</p>
                              
                          </div>
                      </div>
                      <div className="col-lg-6 col-12 text-center pt-3">
                            <div className="container">
                                <div className="row justify-content-center clearfix text-center align-self-center">
                                    <a href="./golf" className="col-lg-6 col-12 p-1 mb-3"><img src="./assets/img/golf/analyze_spine_angle_good.png" alt="Golf swing analysis"/>
                                        <a href="./golf" style={{padding: '5px 20px', background: 'yellowgreen', color: 'white', fontSize:'20px', borderRadius: '5px', marginRight: '20px'}}>All golf &gt;&gt;</a>
									</a>

									<a href="./cricket" className="col-lg-6 col-12 p-1 mb-3"><img src="./assets/img/cricket/analyze_bowling_arm_angle.png" alt="Cricket bowling analysis"/>
							  			<a href="./cricket" style={{padding: '5px 20px', background: 'yellowgreen', color: 'white', fontSize:'20px', borderRadius: '5px'}}>All bowling &gt;&gt;</a>
									</a>
                                    
                                </div>
                            </div>      
                                                                
                      </div>
                      <div className="col-lg-6 col-12  d-none d-lg-block text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Real-time analysis</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 0px 0"  }}>of <a href="./golf" style={{textDecoration: 'underline', fontWeight: 'bold'}}>golf swings</a> and <a href="./cricket" style={{textDecoration: 'underline', fontWeight: 'bold'}}>cricket bowling</a> actions.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

         <section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light.png'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-8 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Slow-motion instant replays</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"  }}>Execute your skill, wait for the delay, and watch the replay. <strong>All hands free.</strong></p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                        <img src="/assets/img/golf/replay_compare.png" alt="Save individual swings"/>
						<p style={{ fontSize: "14px", lineHeight: "1.7", margin: "15px 0 0px 0"  }}>Golf swing &#8226; Cricket bowl<br />Basketball/Netball shot &#8226; Football kick &#8226; Throwing</p>
                      </div>
                  </div>
              </div>
          </section> 

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="d-block d-lg-none col-lg-5 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-pause at key moments</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0",  }}>Pause your golf swing or bowling action, all without touching your phone.</p>
                          </div>
                      </div>
                      <div className="col-lg-7 col-12 text-center">
                        <div className="container">
                            <div className="row justify-content-center clearfix text-center align-self-center">
                                <div className="col-lg-6 col-12 px-lg-4 px-5 py-3">
                                    <img src="/assets/img/golf/auto_pause_section_settings.png" alt="Configure auto-pause" style={{marginBottom: '10px'}}/>
                                    <p >Auto-pause your golf swing at takeaway, top, or impact.</p>
                                </div>
                                <div className="col-lg-6 col-12 px-lg-4 px-5 py-3">
                                    <img src="/assets/img/cricket/auto_pause_bowling.png" alt="Auto-pause at key frames" style={{marginBottom: '10px'}}/>
                                    <p >Auto-pause your bowling action at gather, release, or follow-through.</p>
                                </div>
                                
                            </div>
                        </div>
                          
                      </div>
                      <div className="d-none d-lg-block col-lg-5 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-pause at key moments</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 0px 0",  }}>Pause your golf swing or bowling action, all without touching your phone.</p>
                          </div>
                      </div>
                  </div>

                  <div className="row justify-content-center clearfix mt-5">
                    <div className="col-lg-6 col-12 text-center align-self-center p-2">
                        <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                            <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                            
                            <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                            <a href="#" onClick={() => iphoneRedeemCode("ANALYZER26")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                
                            <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                            <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 13 Apr 2026</div>
                        </div>
                    </div>
                </div>

              </div>
          </section>
          <section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light.png'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-6 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Cast replay to tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 0px 0"  }}>Optionally connect a second device to watch and analyze on a bigger screen, at your feet.</p>
                          </div>
                      </div>
                      <div className="col-lg-6 col-12 text-center">
                        <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={2500}
                                keyBoardControl={true}
                                customTransition="transform 300ms ease-in-out"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                            >
                                <img src="./assets/img/driving_range_pov.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
                                <img src="./watch_at_feet.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
                                <img src="./assets/img/cricket/bowling/view_ipad.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
								
                            </Carousel>

                          
                          
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-8 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-save</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"  }}>All swings or bowls are individually saved, so you can re-watch them with a single tap.</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                          <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings" />
                      </div>
                      <div className="col-lg-8 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>Auto-save</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"}}>All swings or bowls are individually saved, so you can re-watch them with a single tap.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

        

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 className='heading-size' style={{ color:"var(--thm-black"}}>Execute. Learn. Improve. Repeat.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 30px 0" }}>PracticeLoop speeds up your feedback loop, so you can improve faster.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-md-6 col-12 text-center">
						<div className="atf-img-inner" style={{backgroundImage: 'url(./assets/img/smokebg_white_light.png'}}>
							<div className="home-image-box">
								<div>
									<FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '60px' }}></FontAwesomeIcon>
									<h3 className="shake-1">Swing</h3>
									<p>Execute in front of your phone camera</p>
								</div>
								<div>
									<FontAwesomeIcon icon={faRedo} className="loopSpinner"></FontAwesomeIcon>
								</div>
								<div>
									<FontAwesomeIcon icon={faLaptop} style={{ color: 'var(--thm-color)', fontSize: '40px', marginBottom: '5px' }}></FontAwesomeIcon>
									<FontAwesomeIcon icon={faTabletAlt} style={{ color: 'var(--thm-color)', fontSize: '60px', margin: '0px 20px 0 20px' }}></FontAwesomeIcon>
									<FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '40px', margin: '0px 25px 5px 5px' }}></FontAwesomeIcon>
									<h3 className="shake-2">Learn and improve</h3>
									<p>Learn from real-time replays and analysis</p>
								</div>
							</div>
						</div>

					</div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
              <div className="container">
                  <div className="row justify-content-center" style={{backgroundColor: "yellowgreen"}}>
                      <div className="col-12 align-self-center text-center" style={{backgroundImage: 'url(assets/img/golf_collage.png)', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                          <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                              <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>500+ installs</h2><br />
                              <p style={{ display: "inline-block", fontSize: '16px', marginBottom: "10px", lineHeight: "1.5", padding: "3px"}}>Get more from your practice with instant feedback and analysis.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

        

		{(1==2) &&<div className="row">
			<div className="col-12 align-self-center text-center">
				<div>Install the app for free</div>
				<a href="#none" onClick={() => iphoneAppDownload('home_bottom_cta')} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
				<a href="#none" onClick={() => androidAppDownload('home_bottom_cta')} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
			</div>
		</div>}

		

		<Pricing />

		<div className="row justify-content-center clearfix" style={{ background: 'url(./assets/img/smokebg_dark.png',  marginTop: '30px', padding: '25px 5px'}}>
              <div className="col-12 text-center" style={{padding:"20px"}}>
                  <h2 className="heading-size" style={{ margin: "0 0 10px 0", color: 'yellowgreen' }}>The best way to try <LogoText light={true} /></h2>
                  <div style={{color:'white', fontSize:'24px', fontWeight:"normal", lineHeight:'2rem', marginBottom: '20px'}}>is with our Masters Special</div>
                  <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Get analyzer plan free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                    <a href="#" onClick={() => iphoneRedeemCode("ANALYZER26")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                        
                    <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                    <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 15 Apr 2026</div>
              </div>
          </div>

		<div id="get-started" className="atf-section-padding atf-footer-offset">
			<div className="atf-brand-overlay">
				<div className="container">
					<div className="row justify-content-center clearfix wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
						<div className="col-lg-8 col-md-8 col-11 text-center atf-mailchamp-headding atf-mailchamp-subscribe">
							<h2 className="mb-3 text-center">Install the app to get started</h2>
							<div>
								<a href="#none" onClick={() => iphoneAppDownload('home_bottom_cta')} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
								<a href="#none" onClick={() => androidAppDownload('home_bottom_cta')} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
							</div>
							<p style={{color: 'white'}}>* Not all features not available on Android</p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</>
	);
}

export default PracticeLoop;

